export const hasWebNfc = () => typeof window !== "undefined" && "NDEFReader" in window;

const decode = (rec) => new TextDecoder(rec.encoding || "utf-8").decode(rec.data);

export function readUrlFromEvent(e) {
  for (const rec of e.message.records) {
    if (rec.recordType === "url" || rec.recordType === "text" || rec.recordType === "absolute-url") return decode(rec);
  }
  return "";
}

export async function startScan(onUrl, signal) {
  const reader = new window.NDEFReader();
  await reader.scan({ signal });
  reader.onreading = (e) => onUrl(readUrlFromEvent(e), e.serialNumber);
  return reader;
}

export async function readOnce(timeoutMs = 10000) {
  const ctrl = new AbortController();
  const reader = new window.NDEFReader();
  return new Promise((resolve, reject) => {
    const t = setTimeout(() => { ctrl.abort(); reject(new Error("Timed out reading tag")); }, timeoutMs);
    reader.onreading = (e) => { clearTimeout(t); ctrl.abort(); resolve(readUrlFromEvent(e)); };
    reader.scan({ signal: ctrl.signal }).catch((err) => { clearTimeout(t); reject(err); });
  });
}

export async function writeAndVerify(url) {
  const writer = new window.NDEFReader();
  await writer.write({ records: [{ recordType: "url", data: url }] }, { overwrite: true });
  const readBack = await readOnce();
  return { ok: readBack === url, readBack };
}
